import { render } from "./KaiyakuSeisanPage.vue?vue&type=template&id=c9317b20&scoped=true&ts=true"
import script from "./KaiyakuSeisanPage.vue?vue&type=script&lang=ts"
export * from "./KaiyakuSeisanPage.vue?vue&type=script&lang=ts"

import "./KaiyakuSeisanPage.vue?vue&type=style&index=0&id=c9317b20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9317b20"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QCard,QCardSection,QBtn,QSeparator,QCardActions});
